import {
    ISlot,
} from "@/models";

interface ISlotState {
    slots: ISlot[];
}

const initialState: ISlotState = {
    slots: [],
};

export { ISlotState, initialState };
